<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Lab Client Organisation', apiMethod: 'LabClientOrganisations', form: () => import('../forms/LabClientOrganisationForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Sample Sets', value: 'labClientOrganisationId', table: () => import('../tables/SampleSetsTable') },
                ],
                mainForm: () => import('../forms/LabClientOrganisationForm'),
                claimName: 'LabClientOrganisations',
                apiMethod: 'LabClientOrganisations',
            }
        }
    };
</script>
